import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

const useSectionPosition = (sections: NodeListOf<HTMLElement>) => {
  const [progress, setProgress] = useState(0);
  const [scrollPercent, setScrollPercent] = useState(0);

  const updateProgress = useCallback(() => {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    const documentHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const footer = document.querySelector('footer');
    const footerHeight = footer?.offsetHeight || 0;
    const lastSection = sections[sections.length - 1];

    const scrollPosition = window.scrollY;
    const scrollPercent = Math.floor(
      (window.scrollY / (documentHeight - windowHeight)) * 100,
    );

    setScrollPercent(scrollPercent);

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const sectionTop = section.offsetTop;
      const sectionHeight = lastSection
        ? section.offsetHeight - footerHeight
        : section.offsetHeight;

      if (
        scrollPosition >= sectionTop &&
        scrollPosition < sectionTop + sectionHeight
      ) {
        const sectionScrollPosition = scrollPosition - sectionTop;
        const sectionProgress =
          (sectionScrollPosition / sectionHeight) * (100 / sections.length);
        const progressBeforeSection = (i * 100) / sections.length;
        const currentProgress =
          Math.round((progressBeforeSection + sectionProgress) * 100) / 100;

        if (currentProgress >= 99) {
          setProgress(100);
        } else {
          setProgress(currentProgress);
        }
        break;
      }
    }

    if (scrollPosition === 0) {
      setProgress(0);
    }
  }, [sections]);

  useLayoutEffect(() => {
    window.addEventListener('scroll', updateProgress);
    updateProgress();

    return () => window.removeEventListener('scroll', updateProgress);
  }, [updateProgress]);

  useEffect(() => {
    if (scrollPercent >= 99) {
      setProgress(100);
    }
  }, [scrollPercent]);

  return { progress };
};

export default useSectionPosition;
